import { providers } from '../../../providers';
import type { TersaImageModel } from '../../types';
import { defaultSizeNotes } from '../../tools';
import { segmind } from '../../segmind';

export const relightModels: Record<string, TersaImageModel> = {
    relight: {
        chef: providers.flowmuse,
        providers: [
            {
                ...providers.flowmuse,
                model: segmind.image('relight'),
                getCost: () => 0.10,
            },
        ],
        hideInstructions: true,
        tags: ['relight'],
        note: 'tool.relight.title',
        sizes: [],
        sizeNotes: defaultSizeNotes,
        resolutions: [],
        imagesCountOptions: [],
        precheck: [],
        supportsInput: ['i2p'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: '10 credits',
    },
};